function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export { Input, InputGroup, InputLeftElement, InputRightElement, InputLeftAddon, InputRightAddon } from "./ChakraInput";
import { getTypographyStyles } from "../typography/utils";
import { createMultiStyleConfigHelpers } from "../chakra/internal";
import { inputAnatomy as parts } from "../chakra/internal";
const { definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = {
    field: {
        bg: 'background.neutral.tertiary.default',
        borderColor: 'transparent',
        borderWidth: 'border.m',
        borderStyle: 'solid',
        borderRadius: 's',
        position: 'relative',
        boxSizing: 'border-box',
        color: 'text.neutral.primary.default',
        _placeholder: {
            color: 'text.neutral.primary.disabled'
        },
        _hover: {
            backgroundColor: 'background.neutral.tertiary.hovered',
            color: 'text.neutral.primary.hovered'
        },
        _focus: {
            borderColor: 'border.neutral.primary.focused'
        },
        _focusVisible: {},
        _active: {
            borderColor: 'border.neutral.primary.focused'
        },
        _disabled: {
            backgroundColor: 'background.neutral.tertiary.disabled',
            opacity: 1,
            borderColor: 'transparent',
            color: 'text.neutral.primary.disabled',
            _hover: {
                backgroundColor: 'background.neutral.tertiary.disabled',
                color: 'text.neutral.primary.disabled'
            },
            _active: {
                borderColor: 'transparent'
            }
        },
        _invalid: {
            borderColor: 'border.feedback.error.default'
        }
    },
    element: {
        width: 'icon.m'
    },
    addon: {
        bg: 'background.neutral.secondary.default',
        borderRadius: 's',
        color: 'text.neutral.secondary.default'
    }
};
const size = {
    medium: _object_spread_props(_object_spread({}, getTypographyStyles('body.l.default')), {
        height: 'size.xl',
        minHeight: 'size.xl',
        paddingEnd: 'spacing.m',
        paddingStart: 'spacing.l'
    }),
    small: _object_spread_props(_object_spread({}, getTypographyStyles('body.s.default')), {
        height: 'size.m',
        minHeight: 'size.m',
        px: 'spacing.s',
        paddingEnd: 'spacing.m',
        paddingStart: 'spacing.l'
    })
};
const sizes = {
    medium: definePartsStyle({
        field: size.medium,
        element: {
            ms: 'spacing.l',
            me: 'spacing.m'
        },
        addon: {
            px: 'spacing.m'
        }
    }),
    small: definePartsStyle({
        field: size.small,
        element: {
            mx: 'spacing.s'
        }
    })
};
const defaultProps = {
    size: 'medium',
    variant: 'solid'
};
export const ThemedInput = {
    defaultProps: defaultProps,
    sizes,
    baseStyle,
    parts: parts.keys,
    variants: {
        solid: {},
        outline: {}
    }
};

//# sourceMappingURL=Input.js.map